import MarketBase from './market-base';

export default class MarketDateTimeRange extends MarketBase{
    StartDateTime: Array<string> = [];
    EndDateTime: Array<string> = [];
}